import script from "./DealRoomTeamInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./DealRoomTeamInvite.vue?vue&type=script&setup=true&lang=js"

import "./DealRoomTeamInvite.vue?vue&type=style&index=0&id=b17d4710&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b17d4710"]])

export default __exports__